import { registerPlugin } from '../registry';
import type { PluginManifest, PluginContext } from '../types';
import type { Algorithm } from './types';
import LabellingPicker from './components/LabellingPicker';
import LabellingWizard from './components/LabellingWizard';

/**
 * Labelling tool — captures reader ground-truth annotations and posts
 * them to the RMAI backend (see RMAI's DEPLOYMENT.md for the service
 * setup, and CLAUDE.md for the LabelledDataset schema this feeds).
 *
 * Sibling to chiroTools — deliberately DOES NOT modify the auto-detect
 * flow. Both plugins can coexist in the toolbar and be used
 * independently on the same study.
 */

function LabellingIcon() {
  // Crosshair + pin icon — "place a landmark on a target" mental model.
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="8" />
      <line x1="12" y1="2" x2="12" y2="6" />
      <line x1="12" y1="18" x2="12" y2="22" />
      <line x1="2" y1="12" x2="6" y2="12" />
      <line x1="18" y1="12" x2="22" y2="12" />
      <circle cx="12" cy="12" r="2" fill="currentColor" />
    </svg>
  );
}

function openPicker(ctx: PluginContext) {
  const closeAll = () => ctx.hideModal();
  const onSelect = (algorithm: Algorithm) => {
    ctx.showModal(
      <LabellingWizard algorithm={algorithm} ctx={ctx} onClose={closeAll} />,
    );
  };
  ctx.showModal(<LabellingPicker onSelect={onSelect} onClose={closeAll} />);
}

const manifest: PluginManifest = {
  id: 'labellingTool',
  name: 'RMAI Landmark Labelling',
  version: '1.0.0',
  toolbarButtons: [
    {
      id: 'labelling-picker',
      label: 'Label',
      icon: <LabellingIcon />,
      section: 'measurement',
      onClick: openPicker,
    },
  ],
};

registerPlugin(manifest);
